// Bo'laklab yuklash (Q-073): sahifa va ekranlar kerak bo'lganda yuklanadi — telefon kassasi panel kodini olmaydi.
// Yangi versiya chiqib, eski bo'lak serverda qolmagan bo'lsa (kassa kun bo'yi ochiq turadi) — sahifa bir marta
// yangilanadi (savat va navbat saqlanadi: sessionStorage / IndexedDB).
import { lazy } from 'react';
import type { ComponentType, LazyExoticComponent } from 'react';

const RELOAD_KEY = 'onepos.chunk-reload';

export async function loadWithReload<M>(load: () => Promise<M>): Promise<M> {
  try {
    const m = await load();
    try {
      sessionStorage.removeItem(RELOAD_KEY);
    } catch {
      /* saqlab bo'lmadi */
    }
    return m;
  } catch (e) {
    let tried = false;
    try {
      tried = sessionStorage.getItem(RELOAD_KEY) === '1';
      sessionStorage.setItem(RELOAD_KEY, '1');
    } catch {
      tried = true;
    }
    if (!tried && typeof window !== 'undefined') {
      window.location.reload();
      return new Promise<M>(() => undefined);
    }
    throw e;
  }
}

/** Nomli eksport qilingan komponentni bo'lak sifatida: lazyNamed(() => import('./X'), 'X') */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyNamed<M extends Record<K, ComponentType<any>>, K extends keyof M>(load: () => Promise<M>, name: K): LazyExoticComponent<M[K]> {
  return lazy(async () => ({ default: (await loadWithReload(load))[name] }));
}
